// Company subdomain that doesn't exist (or isn't active).
import { QaydLogo } from "components/Brand";
import { rootUrl } from "config/tenant";

export default function CompanyNotFound({ slug }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-center">
      <div className="max-w-[420px]">
        <div className="flex justify-center">
          <QaydLogo size={32} />
        </div>
        <h1 className="m-0 mt-8 text-[22px] font-semibold tracking-[-0.02em] text-fg">Company not found</h1>
        <p className="m-0 mt-2 text-[14px] text-muted">
          There's no Qayd company at <span className="font-medium text-text">{slug}</span>. Check the address, or create a new company.
        </p>
        <div className="mt-6 flex justify-center gap-3 text-[14px]">
          <a href={rootUrl("/login")} className="text-accent no-underline">Find your company</a>
          <span className="text-faint">·</span>
          <a href={rootUrl("/signup")} className="text-accent no-underline">Create a company</a>
        </div>
      </div>
    </div>
  );
}
